import { render } from "./NavSettings.vue?vue&type=template&id=287134f8"
import script from "./NavSettings.vue?vue&type=script&lang=js"
export * from "./NavSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__